// extracted by mini-css-extract-plugin
export default {"table_wrapper":"ListKontrakSegeraBerakhir_table_wrapper__vgdPl"};